import React, { useState } from 'react';
import { Toolbar, Button, IconButton, Stack, Fab, Menu, Box } from '@mui/material';
import UserMenu from './UserMenu';
import Avatar from './Avatar';
import { StartProps } from '../Lessons/Start';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import MenuIcon from '@mui/icons-material/Menu';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import { ItemButtonActions } from '../Solutions/Buttons';
import TimelineActions from '../Timeline/Actions';
import { useNavigate } from 'react-router-dom';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { SidebarMenuProps } from '../Lessons/Sidebar';

const ToggleButton = (props: SidebarMenuProps) => {
  return <IconButton onClick={props.onToggle}>
    {props.open ? <MenuOpenIcon /> : <MenuIcon />}
  </IconButton>
}

const UserNav = (props: StartProps & SidebarMenuProps & ItemButtonActions) => {

  const [showsUserMenu, showUserMenu] = useState(false);
  const [anchorEl, setAnchorEl] = useState();
  const [showsTimelineMenu, showTimelineMenu] = useState(false);
  const [timelineAnchorEl, setTimelineAnchorEl] = useState();

  const navigate = useNavigate();

  const toggleUserMenu = (event) => {
    showUserMenu(!showsUserMenu);
    setAnchorEl(event.currentTarget);
  }

  const toggleTimelineMenu = (event) => {
    showTimelineMenu(!showsTimelineMenu);
    setTimelineAnchorEl(event.currentTarget);
  }

  return (
    <Toolbar sx={{justifyContent: props.size !== "small" ? "space-between" : "flex-start", gap: 2}}>
      <Button onClick={toggleUserMenu}
              size="small"
              startIcon={<Avatar size={32} user={props.user} color="primary" />}
              endIcon={props.size !== "small" && <KeyboardArrowDownIcon color="secondary" sx={{display: {xs: 'none', xl: 'block'}}} />}
              disableRipple
              sx={{px: "0 !important"}}>
        <Box sx={{display: {xs: 'none', xl: 'block'}}}>{props.size !== "small" && props.user?.display_name}</Box>
      </Button>
      <UserMenu {...props}
                anchorEl={anchorEl} 
                open={showsUserMenu}
                onClose={toggleUserMenu} />

      { props.size !== "small" && <Stack direction="row">
        <IconButton color="info" onClick={() => navigate("#invite")}><PersonAddIcon /></IconButton>
        <IconButton onClick={toggleTimelineMenu}><NotificationsNoneIcon /></IconButton>
        <ToggleButton {...props} />
      </Stack> }

      <Menu id="timeline-menu"
            anchorEl={timelineAnchorEl}
            open={showsTimelineMenu}
            onClose={toggleTimelineMenu}
            sx={{[`div.MuiPaper-root`]: { px: 2, py: 1 }}}>
        <TimelineActions {...props} />
      </Menu>
    </Toolbar>
  );
}

export default UserNav;